<template>
  <div v-if="data" class="c-select">
    <div class="c-setion" ref="c-setion" @click="dropdow">
      <input hidden v-model="input" />
      <div>
        <span v-show="selectvalue.length==0" class="select-placeholder">{{name}}</span>
        <Icon class="c-select-arrow" :type="show?'ios-arrow-up':'ios-arrow-down'" />
        <div @click.stop="cancle(idx,key)" v-for="(idx,key) in selectvalue" :key="key" class="c-tag">
          <span>{{idx[clable]}}</span>
          <Icon class="init-ab" type="ios-close" />
        </div>
      </div>
    </div>
    <div class="cselect-dropdown" :style="{'top':`${top}px`}" v-show="show">
      <div class="drop-list">
        <div @click="checkcancle(customer)" :class="{'c-select-item-focus':customer.bo}" :key="customer[cvalue]" :value="customer[cvalue]" v-for="customer in jsondata" class="c-select-item">{{ customer[clable] }}</div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "cselect",
    props: {
      name: {
        type: String,
        default: "请选择"
      },
      data: {
        type: [Object, Array]
      },
      value: {},
      clable: {
        type: String,
        default: "value"
      },
      cvalue: {
        type: String,
        default: "id"
      }
    },
    computed: {
      changeinput() {
        let arr = this.selectvalue.map((item => {
          return item[this.cvalue]
        }))
        return arr
      }
    },
    data() {
      return {
        show: false,
        jsondata: null, //自己的数组
        selectvalue: [], //选中的值
        newvalue: [],
        input: "",
        top:32,
        jishutop:30
      }
    },
    watch: {
      value(value) {
      
        this.init()
      },
      data(newdata) {
        this.init()
      },
      // selectvalue(mew) {

      //   let ar = mew.map((value) => {
      //     return value[this.cvalue]
      //   })
      //   this.input = ar.toString()
      //   this.$emit("input", ar)
      // }
    },
    created() {

    },
    methods: {
      meit() {
        let mew = this.selectvalue
        let ar = mew.map((value) => {
          return value[this.cvalue]
        })
        this.input = ar.toString()
        this.$emit("input", ar)
      },
      iscancle() {
        this.show = false
      },
      cancle(row, key = -1) {
     
        if (key != -1) {
           
          this.selectvalue.splice(key, 1)

          let row1 = JSON.parse(JSON.stringify(row))
          row1.bo = false
          let key1=this.jsondata.findIndex((e)=>e[this.cvalue]==row[this.cvalue])
       
          this.$set(this.jsondata, key1, row1)

        } else {
   
          this.selectvalue = this.selectvalue.filter((item) => {
            return item[this.cvalue] !== row[this.cvalue]
          })
        }
        this.$nextTick(() => {
          this.setheight()
          this.meit()
        })

      },
      checkcancle(row) {
        
        row.bo = !row.bo
        
        this.$nextTick(() => {
         
          if (row.bo) {
            this.selectvalue.push(row)
          } else {
            this.cancle(row)
          }
           
          this.$nextTick(() => {
            this.setheight()
            this.meit()
          })
        })
      },
      calculation(item) {
        let arr = JSON.parse(JSON.stringify(item))
        let value = this.value

        arr = arr.map((item) => {
          item.bo = false
          if (value) {
            value.forEach((item1) => {
              if (item[this.cvalue] == item1) {
                item.bo = true
                this.selectvalue.push(item)
              }
            })
          }

          return item
        })
        return arr
      },
      init() {
        this.jsondata = null //自己的数组
        this.selectvalue = [] //选中的值
        this.newvalue = []
        this.$nextTick(() => {
          if (this.data) {
            this.jsondata = this.calculation(this.data)
          }
        })




      },
      setheight(){
        let setionHeight=this.$refs['c-setion'].clientHeight
           
          let heightmultiple=Math.ceil(setionHeight/this.jishutop)
          this.top=this.jishutop*heightmultiple
      },
      dropdow() {
        if(!this.show){
         this.setheight()
        }
        this.show = !this.show
      }
    }
  }
</script>
<style lang="less" scoped>
  .c-select {
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
    vertical-align: middle;
    color: #515a6e;
    font-size: 14px;
    line-height: normal;

    .c-setion {
      min-height: 32px;
      padding: 0 24px 0 4px;
      display: block;
      box-sizing: border-box;
      outline: none;
      user-select: none;
      cursor: pointer;
      position: relative;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #dcdee2;
      transition: all 0.2s ease-in-out;

    }

    .c-tag {
      height: 24px;
      line-height: 22px;
      margin: 3px 4px 3px 0;
      max-width: 99%;
      position: relative;
      box-sizing: initial;
    }

    .init-ab {
      position: absolute;
      right: 0;
      /* top: 17%; */
      font-size: 18px;
      top: 0;
      line-height: 22px;
    }

    .c-tag {
      display: inline-block;
      height: 22px;
      line-height: 22px;
      margin: 2px 4px 2px 0;
      padding: 0 8px;
      border: 1px solid #e8eaec;
      border-radius: 3px;
      background: #f7f7f7;
      font-size: 12px;
      vertical-align: middle;
      opacity: 1;
      overflow: hidden;
    }

    .c-tag span {
      display: block;
      margin-right: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .c-setion:hover {
      border-color: #3d6cb1;
    }

    .select-placeholder {
      display: block;
      height: 30px;
      line-height: 30px;
      color: #c5c8ce;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 4px;
      padding-right: 22px;
    }

    .c-select-arrow {
      position: absolute;
      top: 50%;
      right: 8px;
      line-height: 1;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      font-size: 14px;
      color: #808695;
      -webkit-transition: all 0.2s ease-in-out;
      transition: all 0.2s ease-in-out;
    }

    .cselect-dropdown {
      min-width: 430px;
      will-change: top, left;
      transform-origin: center top;
      // top: 31px;
      left: 0px;
      position: absolute !important;
      width: auto;
      max-height: 200px;
      overflow: auto;
      margin: 5px 0;
      padding: 5px 0;
      background-color: #fff;
      box-sizing: border-box;
      border-radius: 4px;
      position: absolute;
      z-index: 900;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
      height: 150px;

      .drop-list {
        min-width: 100%;
        list-style: none;

        .c-select-item {
          margin: 0;
          line-height: normal;
          padding: 7px 16px;
          clear: both;
          color: #515a6e;
          font-size: 14px !important;
          white-space: nowrap;
          list-style: none;
          cursor: pointer;
          transition: background 0.2s ease-in-out;
          position: relative;
        }

        .c-select-item-focus {
          //选中了

          color: rgba(12, 71, 157, 0.9);
        }

        .c-select-item:hover {
          background: #f3f3f3;
        }

        .c-select-item-focus::after {

          display: inline-block;
          font-family: Ionicons;
          speak: none;
          font-style: normal;
          font-weight: 400;
          font-variant: normal;
          text-transform: none;
          text-rendering: auto;
          line-height: 1;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          vertical-align: middle;
          font-size: 24px;
          content: "\F171";
          color: rgba(45, 140, 240, .9);
          position: absolute;
          top: 2px;
          right: 8px;
        }
      }
    }
  }
</style>